"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetLinks = void 0;
const resetLinks = attribute => attribute
    // @ts-expect-error Signatures don't match but we don't care
    .clone({ links: { key: undefined, put: undefined, update: undefined } });
exports.resetLinks = resetLinks;
